export enum EIcons {
	ArrowRight = 'ArrowRight',
	Back = 'Back',
	Date = 'Date',
	FlightDown = 'FlightDown',
	FlightUp = 'FlightUp',
	Hotel = 'Hotel',
	LocationMark = 'LocationMark',
	Phone = 'Phone',
	Route = 'Route',
	Pta = 'Pta',
	Star = 'Star',
	Time = 'Time',
}
